<template>
  <div class="content_container">
    <ul class="content_ul" v-show="showContent">
      <li class="content_li" v-for="(item, index) in contentList" :key="index">
        <div class="img_area">
          <div
            class="img_wrap"
            @click="goPath(item)"
            v-if="item.coverMaterialUrl"
            :style="{ 'background-image': `url(${item.coverMaterialUrl})` }"
          >
            <template v-if="!item.isCourse">
              <div
                class="video_png"
                v-show="(showVideoPng && !isOutLine) || item.type == 'VIDEO'"
              >
                <img
                  src="../../assets/images/parent-course/video.png"
                  alt="video"
                />
              </div>
            </template>
            <!-- <img :src="item.coverMaterialUrl | addHost" alt="hi" class="img_s" @click="goPath(item)"> -->
          </div>
          <div class="img_wrap_1" v-if="!item.coverMaterialUrl">
            <div
              class="video_png_1"
              v-if="(showVideoPng && !isOutLine) || item.type == 'VIDEO'"
            >
              <img
                src="../../assets/images/parent-course/video-blank.png"
                alt="video"
                class="img1"
              />
            </div>
            <div class="video_png_2" v-else>
              <img
                src="../../assets/images/parent-course/artical-blank.png"
                alt="video"
                class="img2"
              />
            </div>
          </div>
        </div>
        <div class="sku-description">
          <template
            v-if="
              (!item.isFree && !item.isPay) ||
              (!item.isFree && item.courseType == 2)
            "
          >
            <Price :number="item.price"></Price>
            <van-tag size="medium" color="#1A0801" text-color="#FFE499"
              >付费</van-tag
            >
          </template>
          <h5 class="sku-description-text">{{ item.title }}</h5>
        </div>
        <div
          class="tag_area"
          v-if="item.labels && JSON.parse(item.labels).length > 0"
        >
          <span
            class="tag_wrap"
            v-for="(item, index) in JSON.parse(item.labels).slice(0, 3)"
            :key="index"
            >{{ item.label }}</span
          >
        </div>
        <Dropdown :tags="item.tags"></Dropdown>
        <div class="author">
          <div class="author-circle"></div>
          <span class="author-name">{{ item.author }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Price from "@/components/price/price.vue";
import { Toast } from "vant";
import {
  _getUserConcerned,
  _queryIsPayed,
  _getCourseList,
  _moreCorrelation,
} from "../../api/parent-course";
import Dropdown from "../dropdown/dropdown.vue";
export default {
  name: "second-step",
  components: { Price, Dropdown },
  props: {
    showContent: {
      type: Boolean,
      default: false,
    },
    contentList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showVideoPng: {
      type: Boolean,
      default: false,
    },
    isOutLine: {
      type: Boolean,
      default: false,
    },
    // true 视频 false 文章
    category: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTagArrowArr: [],
      showAlltagsFlag: false,
      tagsWarpHeighArr: [],
      // category: this.showVideoPng
      // 首页-收藏-更多视频（多一个contentId参数）
      concernParams: {
        asc: false,
        currentPage: 1,
        // orderByField:'createTime',
        pageSize: 50, //每页多少条
        queryData: {
          contentId: "",
          contentType: "VIDEO",
        },
      },
      // 推荐和精选下的更多相关视频
      contentParams: {
        asc: false,
        currentPage: 1,
        // orderByField:'createTime',
        pageSize: 50, //每页多少条
        queryData: {
          contentId: "",
          handpick: false,
          tag: "家长",
          top: false,
          recommend: true,
          contentTypeList: ["VIDEO"],
          studentId: "",
        },
      },
      // 各个级别下的视频更多视频的参数
      moreParams: {
        asc: false,
        currentPage: 1,
        // orderByField:'createTime',
        pageSize: 50, //每页多少条
        queryData: {
          columnId: "",
          contentId: "",
          contentType: "VIDEO",
          putaway: true,
        },
      },

      // 购买
      isPayedParams: {
        asc: false,
        currentPage: 1,
        // "orderByField": "createTime",
        pageSize: 5,
        queryData: {
          contentId: "",
          contentType: "VIDEO",
          putaway: false,
        },
      },

      videoInfos: [], //收藏的更多相关视频推荐
      curTab: 1, //默认推荐
    };
  },
  watch: {
    selectId: {
      handler(newval) {
        if (newval) {
          this.contentParams.queryData.studentId = newval;
        }
      },
      immediate: true,
    },
  },
  computed: {
    selectId() {
      return this.$store.state.childId;
    },
  },
  methods: {
    // 监听点击是哪个tab 收藏 || 推荐 || 精选
    initTab() {
      this.$bus.$on("tabChange", (val) => {
        this.curTab = val;
        localStorage.setItem("tabPage", val);
      });
    },
    async goPath(item) {
      if (!item.putaway) {
        Toast("商品已下架！");
        return;
      }
      let temTab = sessionStorage.getItem("tabValue") - 0;
      let num = sessionStorage.getItem("tabTitlelen");
      this.contentParams.queryData.courseId = item.courseId;
      if (temTab === num - 3) {
        //收藏，走收藏的推荐接口
        // 如果是收藏，那么进入收藏视频中的时候，走concerned接口，区别在于多一个contentId字段
        this.concernParams.queryData.courseId = item.id;
        this.concernParams.queryData.contentId = item.id;
        await this.getUserConcerned(this.concernParams);
        this.toWhere(item);
      } else if (!temTab || temTab === 0) {
        //推荐 走相同的putaway接口，多一个字段contentId

        this.contentParams.queryData.contentId = item.id;
        this.contentParams.queryData.recommend = true;
        this.contentParams.queryData.handpick = false;
        await this.getCourseList(this.contentParams);
        this.toWhere(item);
      } else if (temTab === num - 1) {
        //精选 走相同的putaway接口，多一个字段contentId
        this.contentParams.queryData.contentId = item.id;
        this.contentParams.queryData.recommend = false;
        this.contentParams.queryData.handpick = true;
        await this.getCourseList(this.contentParams);
        this.toWhere(item);
      } else if (temTab === num - 2) {
        //已购买
        this.isPayedParams.queryData.contentId = item.id;
        this.isPayedParams.queryData.courseId = item.courseId;
        await this.queryIsPayed(this.isPayedParams);
        this.toWhere(item);
      } else {
        //除了前三个收藏 推荐 精选，其他的都是一级一级的走下来，走到栏目下面，更多相关视频走
        this.moreParams.queryData.contentId = item.id;
        if (localStorage.getItem("labelIds")) {
          this.moreParams.queryData.columnId = localStorage.getItem("labelIds");
        } else {
          this.moreParams.queryData.columnId = item.courseId;
        }
        this.moreParams.queryData.courseId = item.courseId;
        await this.moreCorrelation(this.moreParams);
        this.toWhere(item);
      }
    },
    // 跳转到视频或者文章的路由判断条件
    toWhere(item) {
      localStorage.setItem("paymentDate", JSON.stringify(item));
      let tempInfo = JSON.parse(sessionStorage.getItem("tabInfoDetail"));
      //视频为true 文章为fasle
      if (item.isCourse) {
        //线下课程可以无数次购买
        if (tempInfo && tempInfo.e == "线下课程") {
          this.$router.push(`/coursePlateNopay/${item.courseId}`);
          return;
        } else if (tempInfo && tempInfo.e == "已购买") {
          if (item.courseType == 2) {
            this.$router.push({
              path: "/myOrderDetail",
              query: { id: item.orderId },
            });
            return;
          } else {
            this.$storage.setStore("courseInfo", item);
            this.$router.push(`/coursePlate/${item.courseId}`);
            return;
          }
        } else {
          if (!item.isFree && !item.isPay) {
            this.$router.push(`/coursePlateNopay/${item.courseId}`);
            return;
          } else {
            this.$storage.setStore("courseInfo", item);
            this.$router.push(`/coursePlate/${item.courseId}`);
            return;
          }
        }
      }
      if ((this.showVideoPng && !this.isOutLine) || item.type == "VIDEO") {
        localStorage.setItem("paymentShowVideoPng", this.showVideoPng);
        this.$router.push({
          name: "video",
          query: {
            from: 1,
            videoId: item.id,
            courseId: item.courseId,
          },
        });
        this.$storage.setStore("videoInfo", item);
        this.$storage.setStore("videoInfos", this.videoInfos);
        localStorage.setItem(
          "paymentvideoInfos",
          JSON.stringify(this.videoInfos)
        );
      } else {
        this.$router.push({ name: "artical" });
        this.$storage.setStore("videoInfo", item);
      }
      if (item.courseId) {
        localStorage.setItem("isCourse", item.courseId);
      } else {
        localStorage.removeItem("isCourse");
      }
    },
    // 获取user收藏的内容
    async getUserConcerned(concernParams) {
      try {
        let res = await _getUserConcerned(concernParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.videoInfos = data.records;
          localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
        } else {
          this.videoInfos = [];
          localStorage.removeItem("videoInfos");
          Toast(message);
        }
      } catch (error) {
        this.loading = false;
      }
    },

    // 获取已购买的内容
    async queryIsPayed(isPayedParams) {
      try {
        let res = await _queryIsPayed(isPayedParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.videoInfos = data.records;
          localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
        } else {
          this.videoInfos = [];
          localStorage.removeItem("videoInfos");
          Toast(message);
        }
      } catch (error) {
        this.loading = false;
      }
    },

    // 获取推荐和精选的视频
    async getCourseList(contentParams) {
      try {
        let res = await _getCourseList(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.videoInfos = data.records;
          localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
        } else {
          this.videoInfos = [];
          localStorage.removeItem("videoInfos");
          Toast(message);
        }
      } catch (error) {}
    },
    //各个级别走下去的时候获取更多相关视频
    async moreCorrelation(moreParams) {
      // 如果是
      try {
        let res = await _moreCorrelation(moreParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          if (data && data.records.length > 0) {
            this.videoInfos = data.records;
            localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
            // this.showMore = true
          } else {
            this.videoInfos = [];
            localStorage.removeItem("videoInfos");
          }
        }
      } catch (error) {}
    },
  },
  filters: {
    addHost: function (val) {
      let host = location.host;
      // return 'http://' + host + '/' + val
      //  return 'http://172.16.12.104:8999/' + val
      return val;
    },
  },
  beforeCreate() {},
  created() {
    let columnId = this.$storage.getStore("firstOtherPlateInfo")
      ? this.$storage.getStore("firstOtherPlateInfo").id
      : "";
    this.moreParams.queryData.columnId = columnId;
    this.initTab();
  },
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.content_container {
  .content_ul {
    .content_li {
      width: 335px;
      min-height: 270px;
      margin-bottom: 8px;
      padding-bottom: 12px;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
      // -webkit-backface-visibility: hidden;
      // -webkit-transform: translate3d(0, 0, 0);
      // -webkit-mask-image: -webkit-radial-gradient(white, black);
      .img_area {
        display: flex;
        justify-content: center;
        .img_wrap {
          position: relative;
          width: 100%;
          height: 189px;
          overflow: hidden;
          background-position: center;
          // background-size: 100%;
          background-size: 100%;
          .video_png {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 45px;
            height: 45px;
            .img1 {
              width: 60px;
              height: 45px;
            }
            .img2 {
              width: 45px;
              height: 55px;
            }
            z-index: 10;
          }
          .img_s {
            position: absolute;
            display: block;
            width: 100%;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            margin: auto;
          }
          .img_png {
            width: 315px;
            height: 180px;
          }
        }
        .img_wrap_1 {
          position: relative;
          margin-top: 15px;
          width: 315px;
          height: 180px;
          border-radius: 8px;
          background: #f8f7fa;
          .video_png_1 {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60px;
            height: 45px;
            img {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              top: 0;
              margin: auto;
            }
          }
          .video_png_2 {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 45px;
            height: 55px;
            img {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              top: 0;
              margin: auto;
            }
          }
        }
      }

      .sku-description {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 6px;
        padding: 0px 19px 0 10px;
        .van-tag {
          // margin-left: 10px;
          flex-shrink: 0;
        }
        .sku-description-text {
          margin-left: 4px;
          font-size: 14px;
          color: #2e4344;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .tag_area {
        width: 100%;
        margin: 10px 0;
        text-align: left;

        .tag_wrap {
          display: inline-block;
          min-width: 49px;
          height: 22px;
          line-height: 22px;
          font-size: 12px;
          text-align: center;
          border-radius: 11px;
          margin: 6px;
          padding: 0 10px;
          &:nth-child(5n + 1) {
            background-color: rgba(255, 148, 134, 0.1);
            color: #f56444;
          }
          &:nth-child(5n + 2) {
            background-color: #fff3ea;
            color: #ff8340;
          }
          &:nth-child(5n + 3) {
            background-color: rgba(73, 204, 154, 0.1);
            color: #49cc9a;
          }
          &:nth-child(5n + 4) {
            background-color: rgba(37, 166, 249, 0.1);
            color: #25a6f9;
          }
          &:nth-child(5n + 5) {
            background-color: rgba(157, 154, 255, 0.1);
            color: #887df7;
          }
        }
      }
      .author {
        display: flex;
        align-items: center;
        margin-left: 12px;
        .author-circle {
          width: 16px;
          height: 16px;
          border-radius: 998px;
          background-color: #c3cad6;
        }
        .author-name {
          margin-left: 4px;
          font-size: 12px;
          color: #606f71;
        }
      }
      .tag_area {
        // margin-left: 15px;
        // margin-top: 12px;
        // height: 22px;
        // line-height: 22px;
        // text-align: center;
        // display: inline-block;
        // .tag_wrap {
        //     display: inline-block;
        //     min-width: 49px;
        //     text-align: center;
        //     height: 22px;
        //     line-height: 22px;
        //     border-radius: 11px;
        //     margin: 2px 6px 10px 0px;
        //     p {
        //         display: flex;
        //         justify-content: center;
        //         align-items: center;
        //         box-sizing: border-box;
        //         font-size: 12px;
        //         width: 100%;
        //         height: 100%;
        //         padding: 0px 8px;
        //         // height: 17px;
        //         // line-height: 17px;
        //     }
        //     &:nth-child(5n + 1) {
        //         background-color: rgba(255, 148, 134, .1);
        //         color: #f56444;
        //     }
        //     &:nth-child(5n + 2) {
        //         background-color: #fff3ea;
        //         color: #ff8340;
        //     }
        //     &:nth-child(5n + 3) {
        //         background-color: rgba(73, 204, 154, .1);
        //         color: #49cc9a;
        //     }
        //     &:nth-child(5n + 4) {
        //         background-color: rgba(37, 166, 249, .1);
        //         color: #25a6f9;
        //     }
        //     &:nth-child(5n + 5) {
        //         background-color: rgba(157, 154, 255, .1);
        //         color: #887df7;
        //     }
        // }
      }
      .school_area {
        display: flex;
        align-items: center;
        margin-left: 12px;
        .school_info {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 5px 15px 5px 0px;
          img {
            width: 6px;
            height: 6px;
            display: block;
            margin-right: 2px;
          }
        }
      }
    }
  }
}
</style>
